"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @class Protocols
 * @classdesc Returns Protocols
 */
var Protocols = /** @class */ (function () {
    /**
     *Creates an instance of Protocols.
     * @param {Recover} recover
     * @memberof Protocols
     */
    function Protocols(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof Protocols
         */
        this.index = function () {
            return _this.recover.request("/protocols", "GET", null, null);
        };
        /**
         *
         *
         * @memberof Protocols
         */
        this.create = function (protocol) {
            return _this.recover.request("/protocols", "POST", protocol, null);
        };
        /**
         *
         *
         * @memberof Protocols
         */
        this.single = function (id) {
            return _this.recover.request("/protocols/" + id, "GET", null, null);
        };
        /**
         *
         *
         * @memberof Protocols
         */
        this.edit = function (id, protocol) {
            return _this.recover.request("/protocols/" + id, "PUT", protocol, null);
        };
    }
    return Protocols;
}());
exports.default = Protocols;
